import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initSentry } from './sentry.config'
import { init } from '@plausible-analytics/tracker'

// Initialize Sentry before rendering the app
initSentry()

// Initialize Plausible Analytics
init({
  domain: 'signed.careers',
  captureOnLocalhost: false
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
